import { render, staticRenderFns } from "./SKUs.vue?vue&type=template&id=2ca5a519"
import script from "./SKUs.vue?vue&type=script&lang=js"
export * from "./SKUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports